import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
        flex-direction: row;
    }
`;

export const Login = styled.div`
    text-align: center;
    margin: 0 auto;
    padding: ${rem(20)};

    @media (min-width: ${breakpoints.xs}px) {
        width: ${rem(320)};
    }

    @media (min-width: ${breakpoints.sm}px) {
        padding: ${rem(40)} ${rem(20)};
    }
`;

export const Registration = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${rem(20)};
    border-radius: ${rem(8)};

    @media (min-width: ${breakpoints.sm}px) {
        width: 50%;
        padding: ${rem(40)} ${rem(20)};
    }
`;

export const RegistrationBenefits = styled.div`
    display: flex;
    flex-direction: column;
`;

export const RegistrationBenefitsQuestion = styled.span`
    padding-bottom: ${rem(15)};
`;

export const RegistrationBenefitsAnswer = styled.span`
    padding-bottom: ${rem(5)};
`;

export const RegistrationBenefitsAnswerIcon = styled(IconTemplate)`
    svg {
        width: ${rem(14)};
        height: ${rem(10)};
        opacity: 0.6;
        margin-right: ${rem(10)};
    }
`;

export const Label = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;

export const Description = styled.p`
    line-height: ${rem(24)};
`;
